import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

const useQueryNotification = (options?: any) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["Notifications"],
    queryFn: () => fetchApi("notifications", token).get(),
    staleTime: 10000 * 60 * 10,
    refetchOnWindowFocus: false,
  });
};

export default useQueryNotification;
